import { axiosClient } from 'www/utils'

function writeQuantityViews(videoCardUuid) {
  return axiosClient.post(
    `/api/doctor/video_card/${videoCardUuid}/view_count`,
  )
}

export default writeQuantityViews
